import { Agent, AgentAccessLevel, AgentScope } from "~/services/agents";

// Editing an agent is governed by the caller's resolved access_level (an FGA grant
// surfaced by the API): EDITOR and MANAGER may edit, a USER-level grant is view-only,
// and SYSTEM agents are read-only for everyone.
export const useCanEditAgent = (agent: Agent | undefined): boolean =>
  !!agent &&
  agent.scope !== AgentScope.SYSTEM &&
  (agent.access_level === AgentAccessLevel.EDITOR ||
    agent.access_level === AgentAccessLevel.MANAGER);
